import React from 'react';
import MyLink from 'features/home/components/MyLink';
import { NonogramTopTime } from '@games/api';

const TopTimeRow: React.FC<NonogramTopTime> = ({
  username,
  duration,
  puzzleId
}) => (
  <tr>
    <td>
      {username}
    </td>
    <td className='text-right'>
      {duration}
    </td>
    <td className='text-right'>
      <MyLink href={`/nonogram/puzzle/${puzzleId}`}>
        {puzzleId}
      </MyLink>
    </td>
  </tr>
);

export default TopTimeRow;
